import React from 'react';

interface TimeDueProps {
  value: Date;
}
export const TimeDue = (props: TimeDueProps) => {
  const dateOfProcedure = new Date(props.value);
  const currentDate = new Date();
  const timeDifferenceMs = dateOfProcedure.getTime() - currentDate.getTime();
  const timeDifferenceHours = Math.floor(timeDifferenceMs / (1000 * 60 * 60));
  const days = Math.floor(timeDifferenceHours / 24);
  const remainingHours = timeDifferenceHours % 24;
  let timeDisplay;
  let textColorClass = '';
  console;

  if (days > 0) {
    timeDisplay = `${days} Days`;
  } else if (days < 0) {
    timeDisplay = 'Time Over';
    textColorClass = 'red-text';
  } else {
    timeDisplay = `${remainingHours} Hrs`;
    textColorClass = timeDifferenceHours <= 24 ? 'red-text' : ''; // Apply red text class if due time has passed
  }

  return <div className={textColorClass}>{timeDisplay}</div>;
};